import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=bb27eaec&scoped=true"
import script from "./VoucherList.vue?vue&type=script&lang=js"
export * from "./VoucherList.vue?vue&type=script&lang=js"
import style0 from "./VoucherList.vue?vue&type=style&index=0&id=bb27eaec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27eaec",
  null
  
)

export default component.exports